// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
:host .root {
  position: relative;
  background: var(--person-card-background-color, #ffffff);
  width: var(--mgt-flyout-set-width, 340px);
  font-family: var(--default-font-family); }
  :host .root .person-details-container {
    display: flex;
    padding: 18px 14px; }
    :host .root .person-details-container mgt-person.person-image {
      --avatar-size: 75px; }
    :host .root .person-details-container .details {
      margin-left: 14px;
      line-height: 1.15;
      display: grid;
      position: relative;
      overflow: hidden;
      text-overflow: ellipse;
      white-space: nowrap;
      background-color: transparent;
      width: 100%; }
      :host .root .person-details-container .details .display-name {
        font-size: var(--person-card-display-name-font-size, 27.3103px);
        color: var(--person-card-display-name-color, #333333); }
        :host .root .person-details-container .details .display-name::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          right: 0;
          background: linear-gradient(left, transparent, transparent 80%, var(--person-card-background-color, #ffffff));
          background: -moz-linear-gradient(left, transparent, transparent 80%, var(--person-card-background-color, #ffffff));
          background: -o-linear-gradient(left, transparent, transparent 80%, var(--person-card-background-color, #ffffff));
          background: -ms-linear-gradient(left, transparent, transparent 80%, var(--person-card-background-color, #ffffff));
          background: -webkit-linear-gradient(left, transparent, transparent 80%, var(--person-card-background-color, #ffffff)); }
      :host .root .person-details-container .details .job-title {
        font-size: var(--person-card-title-font-size, 18.2069px);
        color: var(--person-card-title-color, #767676); }
      :host .root .person-details-container .details .department {
        font-size: var(--person-card-subtitle-font-size, 15.1724px);
        color: var(--person-card-subtitle-color, #767676); }
      :host .root .person-details-container .details .base-icons {
        margin-top: 14px;
        display: flex;
        -webkit-align-items: center;
        align-items: center;
        max-width: 120px; }
        :host .root .person-details-container .details .base-icons .icon {
          margin: 0 22px 0 0;
          cursor: pointer; }
        :host .root .person-details-container .details .base-icons .icon:hover {
          opacity: 0.6; }
  :host .root .expanded-details-container .expanded-details-button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    background: rgba(196, 196, 196, 0.1); }
    :host .root .expanded-details-container .expanded-details-button .expanded-details-svg {
      margin-bottom: 3px; }
  :host .root .expanded-details-container .expanded-details-button:hover {
    background-color: rgba(0, 0, 0, 0.068); }
  :host .root .expanded-details-container .expanded-details-info {
    margin: 0 0 0 20px;
    padding-bottom: 18px;
    display: flex;
    flex-direction: column; }
    :host .root .expanded-details-container .expanded-details-info .contact-text {
      margin: 0 0 24px 0;
      font-weight: 600;
      font-size: var(--person-card-details-title-font-size, 14px);
      color: var(--person-card-details-title-color, #000000); }
    :host .root .expanded-details-container .expanded-details-info .icons {
      line-height: normal;
      font-style: normal;
      font-weight: normal;
      font-size: var(--person-card-details-item-font-size, 15px);
      color: var(--person-card-details-item-color, #201f1e);
      text-align: left; }
      :host .root .expanded-details-container .expanded-details-info .icons .details-icon {
        margin: 0 0 10px 0;
        display: flex;
        flex-direction: row;
        align-items: center; }
    :host .root .expanded-details-container .expanded-details-info .data {
      display: block;
      margin: 0 0 0px 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 280px; }
    :host .root .expanded-details-container .expanded-details-info .normal-subtitle {
      padding-top: 2px; }
    :host .root .expanded-details-container .expanded-details-info .link-subtitle {
      color: #3078cd;
      cursor: pointer; }
    :host .root .expanded-details-container .expanded-details-info .link-subtitle:hover {
      opacity: 0.6; }
  :host .root .expanded-details-container .section-divider {
    width: 96%;
    height: 1px;
    background: #eaeaea; }

`
];
//# sourceMappingURL=mgt-person-card-css.js.map